import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import StoregmIcon from '../assets/icons/store.png'
import SidebarArrow from '../assets/icons/sidebar_arrow.png'
import SysAdminIcon from '../assets/icons/user.png'
import DevOppIcon from '../assets/icons/iteration.png'
import Dashboard from '../assets/icons/dashboard.png'
import { filterMenuByPermissions} from "../utils/mics";
import { useDispatch } from "react-redux";
import appActions from "../appActions";
// import { Tooltip } from "primereact/tooltip";

export const sideMenuItems = [
    {
        key: "M01",
        label: "Dashboard",
        icon: Dashboard,
        keywords: "dashboard",
        marginDimension: "0.5em",
        highlightClass: "",
        module: "dashboard",
        configaccess: "showBroker",
        path: "/ui/dashboard",
        child: [
            {
                key: "M01-1-R",
                label : "Read",
                value: true
            },
            {
                key: "M01-1-W",
                label : "Write",
                value: true
            },
            {
                key: "M01-1-D",
                label : "Delete",
                value: true
            }
        ]
    },
    {
        key: "M02",
        label: "Integration",
        icon: StoregmIcon,
        keywords: "consumer management,producer management",
        marginDimension: "0.5em",
        childMenu: "integrationSubMenu",
        highlightClass: "",
        module: "Integration",
        configaccess: "showBroker",
        children: [
            {
                key: "M02-1",
                label: "Store",
                path: "/ui/system-store",
                group: "Integration",
                module: "Store",
                menuIcon: 'pi pi-shopping-bag',
                child: [
                    {
                        key: "M02-1-R",
                        label : "Read",
                        value: true
                    },
                    {
                        key: "M02-1-W",
                        label : "Write",
                        value: true
                    },
                    {
                        key: "M02-1-D",
                        label : "Delete",
                        value: true
                    },
                    {
                        key: "M02-1-XP",
                        label : "Export",
                        value: true
                    }
                ],
                action : "SYSSTORE"
            },
            {
                key: "M02-2",
                label: "Configuration",
                path: "/ui/prop-confg",
                group: "Integration",
                module: "propconfig",
                menuIcon: 'pi pi-cog',
                child: [
                    {
                        key: "M02-2-R",
                        label : "Read",
                        value: true
                    },
                    {
                        key: "M02-2-W",
                        label : "Write",
                        value: true
                    },
                    {
                        key: "M02-2-D",
                        label : "Delete",
                        value: true
                    },
                     {
                        key: "M02-2-XP",
                        label : "Export",
                        value: true
                    }
                ],
                action : "PROPCONFIG"
            },
            {
                key: "M02-3",
                label: "Integration File ",
                path: "/ui/integration-file",
                group: "Integration",
                module: "File",
                menuIcon: 'pi pi-folder-open',
                child: [
                    {
                        key: "M02-3-R",
                        label : "Read",
                        value: true
                    },
                    {
                        key: "M02-3-W",
                        label : "Write",
                        value: true
                    },
                    {
                        key: "M02-3-D",
                        label : "Delete",
                        value: true
                    },
                     {
                        key: "M02-3-XP",
                        label : "Export",
                        value: true
                    }
                ],
                action : "INTFILE"
            },
            {
                key: "M02-4",
                label: "Integration File Log",
                path: "/ui/integration-file-log",
                group: "Integration",
                module: "FileLog",
                menuIcon: 'pi pi-file-o',
                child: [
                    {
                        key: "M02-4-R",
                        label : "Read",
                        value: true
                    },
                    {
                        key: "M02-4-W",
                        label : "Write",
                        value: true
                    },
                    {
                        key: "M02-4-D",
                        label : "Delete",
                        value: true
                    },
                     {
                        key: "M02-4-XP",
                        label : "Export",
                        value: true
                    }
                ],
                action : "INTFILELOG"
            },
            {
                key: "M02-5",
                label: "Integration Outbound File",
                path: "/ui/int-outbound-file",
                group: "Integration",
                module: "outBoundFile",
                menuIcon: 'pi pi-file-o',
                child: [
                    {
                        key: "M02-5-R",
                        label : "Read",
                        value: true
                    },
                    {
                        key: "M02-5-W",
                        label : "Write",
                        value: true
                    },
                    {
                        key: "M02-5-D",
                        label : "Delete",
                        value: true
                    },
                     {
                        key: "M02-5-XP",
                        label : "Export",
                        value: true
                    }
                ],
                action : "INTOUTBOUNDFILE"
            },
            {
                key: "M02-6",
                label: "Integration Schedule Queue",
                path: "/ui/file-upload-queue",
                group: "Integration",
                module: "UploadQueue",
                menuIcon: 'pi pi-cloud-upload',
                child: [
                    {
                        key: "M02-6-R",
                        label : "Read",
                        value: true
                    },
                    {
                        key: "M02-6-W",
                        label : "Write",
                        value: true
                    },
                    {
                        key: "M02-6-D",
                        label : "Delete",
                        value: true
                    },
                     {
                        key: "M02-6-XP",
                        label : "Export",
                        value: true
                    }
                ],
                action : "FILEUPLOAD"
            },
            {
                key: "M02-7",
                label: "POS Journal File",
                path: "/ui/pos-journal",
                group: "Integration",
                module: "PosJournal",
                menuIcon: 'pi pi-wallet',
                child: [
                    {
                        key: "M02-7-R",
                        label : "Read",
                        value: true
                    },
                    {
                        key: "M02-7-W",
                        label : "Write",
                        value: true
                    },
                    {
                        key: "M02-7-D",
                        label : "Delete",
                        value: true
                    },
                    {
                        key: "M02-7-XP",
                        label : "Export",
                        value: true
                    }
                ],
                action : "POSJOURNAL"              
            },
            {
                key: "M02-8",
                label: "Store Items",
                path: "/ui/store-items",
                group: "store-items",
                module: "store-items",
                menuIcon: 'pi pi-database',
                child: [
                    {
                        key: "M02-8-R",
                        label : "Read",
                        value: true
                    },
                    {
                        key: "M02-8-W",
                        label : "Write",
                        value: true
                    },
                    {
                        key: "M02-8-D",
                        label : "Delete",
                        value: true
                    },
                    {
                        key: "M02-8-XP",
                        label : "Export",
                        value: true
                    }
                ],
                action : "STOREITEMS"  
            },
            {
                key: "M02-9",
                label: "System ApiLogs",
                path: "/ui/sys-apilogs",
                group: "sys-apilogs",
                module: "sys-apilogs",
                menuIcon: 'pi pi-stop',
                child: [
                    {
                        key: "M02-9-R",
                        label : "Read",
                        value: true
                    },
                    {
                        key: "M02-9-W",
                        label : "Write",
                        value: true
                    },
                    {
                        key: "M02-9-D",
                        label : "Delete",
                        value: true
                    },
                    {
                        key: "M02-9-XP",
                        label : "Export",
                        value: true
                    }
                ],
                action : "APILOGS"
            },
            {
                key: "M02-10",
                label: "POS Command Events",
                path: "/ui/sys-events",
                group: "sys-events",
                module: "sys-events",
                menuIcon: 'pi pi-stop',
                child: [
                    {
                        key: "M02-10-R",
                        label : "Read",
                        value: true
                    },
                    {
                        key: "M02-10-W",
                        label : "Write",
                        value: true
                    },
                    {
                        key: "M02-10-D",
                        label : "Delete",
                        value: true
                    },
                    {
                        key: "M02-10-XP",
                        label : "Export",
                        value: true
                    }
                ],
                action : "SYSEVENTS"
            }              
        ],
    },
    {
        key: "M03",   
        label: "System Admin",
        icon: SysAdminIcon,
        keywords: "consumer management,producer management",
        marginDimension: "0.5em",
        childMenu: "systemAdmin",
        highlightClass: "",
        module: "systemAdmin",
        configaccess: "showBroker",
        children: [
            {
                key: "M03-1",
                label: "File Management",
                path: "/ui/media-management",
                group: "systemAdmin",
                module: "systemAdmin",
                menuIcon: 'pi pi-file',
                child: [
                    {
                        key: "M03-1-R",
                        label : "Read",
                        value: true
                    },
                    {
                        key: "M03-1-DL",
                        label : "Download",
                        value: true
                    },
                    {
                        key: "M03-1-D",
                        label : "Delete",
                        value: true
                    },
                    {
                        key: "M03-1-UP",
                        label : "File Upload",
                        value: true
                    }
                ]
            },
            {
                key: "M03-2",
                label: "Users Management",
                path: "/ui/users-management",
                group: "systemAdmin",
                module: "systemAdmin",
                menuIcon: 'pi pi-user',
                child: [
                    {
                        key: "M03-2-R",
                        label : "Read",
                        value: true
                    },
                    {
                        key: "M03-2-W",
                        label : "Write",
                        value: true
                    },
                    {
                        key: "M03-2-D",
                        label : "Delete",
                        value: true
                    },
                    {
                        key: "M03-2-XP",
                        label : "Export",
                        value: true
                    }
                ]  
            },
            {
                key: "M03-5",
                label: "Role Management",
                path: "/ui/roles-management",
                group: "systemAdmin",
                module: "systemAdmin",
                menuIcon: 'pi pi-key',
                child: [
                    {
                        key: "M03-5-R",
                        label : "Read",
                        value: true
                    },
                    {
                        key: "M03-5-W",
                        label : "Write",
                        value: true
                    },
                    {
                        key: "M03-5-D",
                        label : "Delete",
                        value: true
                    },
                    {
                        key: "M03-5-XP",
                        label : "Export",
                        value: true
                    }
                ]  
            },
            {
                key: "M03-3",
                label: "System Error Codes",
                path: "/ui/system-error-codes",
                group: "systemAdmin",
                module: "systemAdmin",
                menuIcon: 'pi pi-check-square',
                child: [
                    {
                        key: "M03-3-R",
                        label : "Read",
                        value: true
                    },
                    {
                        key: "M03-3-W",
                        label : "Write",
                        value: true
                    },
                    {
                        key: "M03-3-D",
                        label : "Delete",
                        value: true
                    },
                    {
                        key: "M03-3-XP",
                        label : "Export",
                        value: true
                    }
                ],
                action : "SYSERRORCODE"             
            },
            {
                key: "M03-4",
                label: "System App Logger",
                path: "/ui/system-app-logger",
                group: "systemAdmin",
                module: "systemAdmin",
                menuIcon: 'pi pi-box',
                child: [
                    {
                        key: "M03-4-R",
                        label : "Read",
                        value: true
                    },
                    {
                        key: "M03-4-D",
                        label : "Delete",
                        value: true
                    },
                    {
                        key: "M03-4-XP",
                        label : "Export",
                        value: true
                    }
                ],
                action : "SYSAPPLOGGER"
            },
            {
                key: "M03-5",
                label: "Store System ID Config",
                path: "/ui/store-system-id-config",
                group: "systemAdmin",
                module: "systemAdmin",
                menuIcon: 'pi pi-cog',
                child: [
                    {
                        key: "M03-4-R",
                        label : "Read",
                        value: true
                    },
                    {
                        key: "M03-4-D",
                        label : "Delete",
                        value: true
                    },
                    {
                        key: "M03-4-XP",
                        label : "Export",
                        value: true
                    }
                ],
                action : "STORESYSID"
            },
        ]
    },
    {
        key: "M04",
        label: "Devops Tool",
        icon: DevOppIcon,
        keywords: "pdevops management",
        marginDimension: "0.5em",
        childMenu: "devOpsTool",
        highlightClass: "",
        module: "systemAdmin",
        configaccess: "showBroker",
        children: [
            {
                key: "M04-1",
                label: "Export Table Logs",
                path: "/ui/devopstool/export/table-log",
                group: "systemAdmin",
                module: "DevOpsTool",
                menuIcon: 'pi pi-book',
                child: [
                    {
                        key: "M04-1-R",
                        label : "Read",
                        value: true
                    },
                    // {
                    //     key: "M04-1-W",
                    //     label : "Write",
                    //     value: true
                    // },
                    // {
                    //     key: "M04-1-D",
                    //     label : "Delete",
                    //     value: true
                    // }
                ] 
            },
            {
                key: "M04-6",
                label: "Export File Logs",
                path: "/ui/devopstool/export/file-log",
                group: "systemAdmin",
                module: "DevOpsTool",
                menuIcon: 'pi pi-book',
                child: [
                    {
                        key: "M04-6-R",
                        label : "Read",
                        value: true
                    },
                    // {
                    //     key: "M04-1-W",
                    //     label : "Write",
                    //     value: true
                    // },
                    // {
                    //     key: "M04-1-D",
                    //     label : "Delete",
                    //     value: true
                    // }
                ] 
            },
            {
                key: "M04-2",
                label: "Table Cleanup",
                path: "/ui/devopstool/cleanup-table",
                group: "systemAdmin",
                module: "DevOpsTool",
                menuIcon: 'pi pi-file',
                child: [
                    // {
                    //     key: "M04-2-R",
                    //     label : "Read",
                    //     value: true
                    // },
                    // {
                    //     key: "M04-2-W",
                    //     label : "Write",
                    //     value: true
                    // },
                    {
                        key: "M04-2-D",
                        label : "Delete",
                        value: true
                    }
                ] 
            },
            {
                key: "M04-3",
                label: "Disk Cleanup",
                path: "/ui/devopstool/cleanup-disk",
                group: "systemAdmin",
                module: "DevOpsTool",
                menuIcon: 'pi pi-desktop',
                child: [
                    // {
                    //     key: "M04-3-R",
                    //     label : "Read",
                    //     value: true
                    // },
                    // {
                    //     key: "M04-3-W",
                    //     label : "Write",
                    //     value: true
                    // },
                    {
                        key: "M04-3-D",
                        label : "Delete",
                        value: true
                    }
                ] 
            },
            {
                key: "M04-4",
                label: "Logs Cleanup",
                path: "/ui/devopstool/cleanup-log",
                group: "systemAdmin",
                module: "DevOpsTool",
                menuIcon: 'pi pi-cog',
                child: [
                    // {
                    //     key: "M04-4-R",
                    //     label : "Read",
                    //     value: true
                    // },
                    // {
                    //     key: "M04-4-W",
                    //     label : "Write",
                    //     value: true
                    // },
                    {
                        key: "M04-4-D",
                        label : "Delete",
                        value: true
                    }
                ] 
            },
            {
                key: "M04-5",
                label: "Logs Parser",
                path: "/ui/devopstool/logs-parser",
                group: "systemAdmin",
                module: "DevOpsTool",
                menuIcon: 'pi pi-clock',
                child: [
                    {
                        key: "M04-5-R",
                        label : "Read",
                        value: true
                    },
                    // {
                    //     key: "M04-5-W",
                    //     label : "Write",
                    //     value: true
                    // },
                    // {
                    //     key: "M04-5-D",
                    //     label : "Delete",
                    //     value: true
                    // }
                ] 
            }
        ]
    }
]

const Sidebar = (props) => {

    const { userRole, userPermissions } = props;

    const dispatch = useDispatch();

    const [routesForSideBar, setRoutesForSideBar] = useState(sideMenuItems);

    useEffect(() => {
        // Filter the side menu items based on user permissions
        const filteredMenu = filterMenuByPermissions(sideMenuItems, userPermissions);
        setRoutesForSideBar(filteredMenu);
    }, [userRole, userPermissions]);


    const [activeIndex, setActiveIndex] = useState("1");
    const refContainer = useRef({});

    const [leaveAction, setLeaveAction] = useState(null); 

    const useClearFiltersOnLeave = (actionBaseName) => {
        useEffect(() => {
            return () => {
                if (actionBaseName) {
                    const actionFn = appActions[`${actionBaseName}_SET_FILTERS_REQUEST`];
                    if (typeof actionFn === "function") {
                        dispatch(actionFn({}));
                    }
                }
            };
        }, [dispatch, actionBaseName]);
    };

    // Call hook at top level with current action
    useClearFiltersOnLeave(leaveAction);

    const _setRef = (element) => {
        if (element) refContainer.current[element.id] = element;
    };

    const _collapseRef = (id, parent, index) => {
        const _refContainer = refContainer.current;
    
        if (!parent) {
            return;
        } else {
            for (const key of Object.keys(_refContainer)) {
                if (_refContainer[key].classList.contains("show")) {
                    if (
                        key !== id &&
                        !index.startsWith(activeIndex + "_") &&
                        activeIndex !== index
                    ) {
                        _refContainer[key].classList.toggle("show");
                        _refContainer[
                            key
                        ].previousSibling.lastElementChild.classList.remove(
                            "rotate_down"
                        );
                        _refContainer[
                            key
                        ].previousSibling.lastElementChild.classList.add(
                            "rotate"
                        );
                    }
                }
            }
    
            if (id) {
                _refContainer[id].classList.toggle("show");
    
                if (_refContainer[id].classList.contains("show")) {
                    _refContainer[
                        id
                    ].previousSibling.lastElementChild.classList.add(
                        "rotate_down"
                    );
                } else {
                    _refContainer[
                        id
                    ].previousSibling.lastElementChild.classList.remove(
                        "rotate_down"
                    );
                    _refContainer[
                        id
                    ].previousSibling.lastElementChild.classList.add("rotate");
                }
            }
        }
    };    

    const _matchIndex = (index) => {
        const splitTexts = index.split("_");
        return (
            splitTexts.findIndex(
                (splitText) =>
                    activeIndex === splitText ||
                    activeIndex.startsWith(splitText + "_")
            ) > -1
        );
    };

    
    const _drawMenuWithNoChild = (
        index,
        module,
        highlightClass,
        icon,
        isSideBarActive,
        path,
        label,
        marginDimension,
        menuIcon,
        action
    ) => {
        return (   
            <li
                key={index}
                style={{ display: "block" }}
                onClick={() => {
                    // Ensure sidebar remains open when clicking on a menu without children
                    _collapseRef("", true, index);
                    setLeaveAction(action); // trigger hook via state
                    setActiveIndex(index);
                }}
                id={`tooltip_with_no_child_${index + 1}`}
                className={
                    isSideBarActive
                        ? _matchIndex(index)
                            ? `nav-selected tp`
                            : `${highlightClass}`
                        : "tp"
                }
                data-pr-tooltip={label}
            >
            <Link
                    to={path}
                    className={
                        isSideBarActive ? "" : _matchIndex(index) ? `nav-selected` : `${highlightClass}`
                    }
                >
                    {icon && <img alt={label} src={icon} />}
                    {menuIcon && <i className={menuIcon}></i>}
                    <span
                        className="menu-item"
                        style={{ marginLeft: marginDimension, paddingLeft: 0, justifyContent: !isSideBarActive ? 'center' : 'left' }}
                    >
                        {label}
                    </span>
                </Link>
                <span className="hover_span">{label}</span>
            </li>
        );
    };
    
    const _drawChild = (children, childMenu, index, action) => {
        const { label, path, icon, menuIcon } = children;
        return (
        
            <li
                key={index}
                style={{ display: "block" }}
                onClick={(event) => {
                    _collapseRef(childMenu, false, index);
                     setLeaveAction(action); // trigger hook via state
                    event.stopPropagation();
                }}
                className="tp"
                id={`tooltip_${index}`}
                data-pr-tooltip={ label }
            >

                <Link to={path} style={{    paddingLeft: isSideBarActive ? '10px' : '0',  justifyContent:  !isSideBarActive ? 'center' : 'left' }}>
                { icon && <img alt={label} src={icon} />} 
                { menuIcon && <i className={menuIcon}></i> }
                    {isSideBarActive && <span
                        className="menu-item"
                        style={{paddingLeft: 0 }}
                    >
                        {label}
                    </span>}
                </Link>
            </li>
        );
    };

    const _drawMenuWithChild = (
        children,
        childMenu,
        index,
        module,
        highlightClass,
        icon,
        isSideBarActive,
        path,
        label,
        marginDimension,
        menuIcon,
        key
    ) => {
        return (
            <li
                key={key}
                style={{ display: "block" }}
                onClick={(event) => {
                    _collapseRef(childMenu, true, index);
                    setActiveIndex(index);
                    event.stopPropagation();
                }}
                id={`tooltip_with_child_${index}`}
                className={
                    !isSideBarActive
                        ? _matchIndex(index)
                            ? `nav-selected parent_li`
                            : `${highlightClass} parent_li`
                        : "parent_li"
                }
            >
                <a
                    href="/"
                    onClick={(event) => event.preventDefault()}
                    data-toggle="collapse"
                    aria-expanded="false"
                    className={
                        isSideBarActive
                            ? ""
                            : _matchIndex(index)
                            ? `nav-selected`
                            : `${highlightClass}`
                    }
                    style={{ display: 'flex', alignItems: 'center',  justifyContent:  !isSideBarActive ? 'center' : 'left'}}
                >
                    {icon && <img alt={label} src={icon} />}
                    {menuIcon && <i className={menuIcon}></i> }
                    <span
                        className="menu-item"
                        style={{ marginLeft: marginDimension, paddingLeft: 0,  justifyContent:  !isSideBarActive ? 'center' : 'left' }}
                    >
                        {label}
                    </span>
                    <img
                        alt=""
                        id="dropdown"
                        className="sidebar_dropdown rotate"
                        style={{ height: "0.8em", width: "0.8em" }}
                        src={SidebarArrow}
                    />
                </a>
                <ul
                    className={`collapse list-unstyled ${_matchIndex(index) ? "show" : ""}`} // Conditionally add 'show'
                    style={{ paddingLeft: `${index.split("_").length - 1}em`, justifyContent: !isSideBarActive ? 'center' : 'left' }}
                    id={childMenu}
                    data-parent="#sidebar"
                    ref={_setRef}
                >
                    {children.map((subChild, subIndex) => {
                        if (typeof subChild.children !== "undefined") {
                            return _drawMenu(
                                subChild,
                                `${index}_${subChild.childMenu}`
                            );
                        } else {
                            return _drawChild(
                                subChild,
                                childMenu,
                                `${index}_${subIndex.toString()}`,
                                subChild.action

                            );
                        }
                    })}
                </ul>
                {/* <span className="hover_span">{label}</span> */}
            </li>
        );
    };

    const _drawMenu = (route, index) => {
        const {
            path,
            icon,
            label,
            children,
            childMenu,
            marginDimension,
            highlightClass,
            module,
            menuIcon,
            key,
            action
        } = route;

        const { isSideBarActive } = props;
        if (label === "ADMIN") {
            return (
                <li key={index} className="admindiv">
                    {label}
                </li>
            );
        } else if (typeof children === "undefined") {
            return _drawMenuWithNoChild(
                index,
                module,
                highlightClass,
                icon,
                isSideBarActive,
                path,
                label,
                marginDimension,
                menuIcon,
                key,
                action
            );
        } else {
            return _drawMenuWithChild(
                children,
                childMenu,
                index,
                module,
                highlightClass,
                icon,
                isSideBarActive,
                path,
                label,
                marginDimension,
                menuIcon,
                key
            );
        }
    };

    const { isSideBarActive } = props;
    
    return (
        <nav id="sidebar" className={!isSideBarActive ? "active " : ""}>
            {/* <div style={{ padding: "1.2em 0" }}>
                <span className="sidebaractive-header"></span>
                <div
                    className="menu"
                    style={{ display: "inline" }}
                    onClick={() => props.toggleSideBar()}
                ></div>
            </div> */}
            <ul className="list-unstyled components">
                {routesForSideBar.map((route, index) =>
                    _drawMenu(route, index.toString())
                )}
            </ul>
        </nav>
    );
};

export default Sidebar;
